import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../welltect.constants';

@Component({
  selector: 'app-welltect-change-password-sent',
  templateUrl: './welltect-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './welltect-change-password-sent.component.css',
  ],
})
export class WelltectChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
